export const FilterConfigColumnProp = Object.freeze({
    CurrentFilterIndex: 'currentFilterIndex',
    DefaultComparator: 'defaultComparator',
    Comparators: 'comparators',
    ValueFields: 'valueFields',
});
